import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AccessibleElement from './accessible-element';
import AdaptiveImage from '../../shared/components/adaptive-image';

import './radio-button.less';

function RadioButton({ className, ariaLabel, value, name, label, color, checked, variation, title, info, colorHex, imageUrl }) {
    const id = `${name}-${label}-${value}`;
    const containerClass = `radio-button ${color}${variation ? ' '+variation :''}${className ? ' '+className:''}${checked ? ' checked':''}`;
    return (<AccessibleElement element='label' ariaLabel={ariaLabel || label} className={containerClass} htmlFor={id}>
        {imageUrl && <AdaptiveImage src={imageUrl} desktopWidth={80} />}
        {colorHex && <span className='color-swatch' style={{backgroundColor: colorHex}}></span>}
        <div className='radio-label'>
            {title && <b className={'radio-title'}>{title}</b>}
            {label}
        </div>
        <input type='radio' id={id} value={value} name={name} tabIndex={-1} defaultChecked={checked}/>
        <div className='custom-radio'></div>
        {info && <div className={'radio-info'}>{info}</div>}
    </AccessibleElement>);
}

RadioButton.propTypes = {
    /** title text to appear above the label */
    title: PropTypes.string,
    /** Display name for the label of the radio button */
    label: PropTypes.string,
    /** Additional info about radio option */
    info: PropTypes.string,
    /** Value of the radio button */
    value: PropTypes.any.isRequired,
    /** Additional class names */
    className: PropTypes.string,
    /** custom aria label */
    ariaLabel: PropTypes.string,
    color: PropTypes.oneOf(['light', 'dark']),
    /** Variant display types */
    variation: PropTypes.oneOf(['default','tile']),
    /** HEX value to add a color swatch to the ratio button */
    colorHex: PropTypes.string,
    /** Link to image to be displayed */
    imageUrl: PropTypes.string
};

RadioButton.defaultProps = {
    color: 'light',
    variation: 'default'
}


export default React.memo(RadioButton);
